var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 33,
    viewBox: "0 0 182 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10713_4553)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.51353 25.2581L10.0531 17.7187L12.5642 20.2299L15.4928 17.3013L10.0531 11.8616C6.93106 14.9836 3.80918 18.1055 0.687134 21.2276C1.11555 22.6628 1.73409 24.0161 2.51353 25.2581Z",
    fill: "#40B4B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66101 28.9411C6.72067 29.8651 7.89965 30.6559 9.17154 31.2876C14.067 26.3922 18.9626 21.4967 23.8579 16.6012L31.2198 23.9631C31.9098 22.6049 32.4171 21.1384 32.7098 19.596C29.7591 16.6455 26.8087 13.6946 23.8579 10.7441C17.7922 16.8098 11.7267 22.8754 5.66101 28.9411Z",
    fill: "#40B4B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21901 23.3606L3.2478 26.3318C3.70213 26.9431 4.19755 27.5218 4.73027 28.064L7.6589 25.1353C7.12651 24.5904 6.64397 23.9963 6.21901 23.3606Z",
    fill: "#40B4B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.326265 19.7807L4.15349 15.9535C4.43949 9.38166 9.85777 4.14144 16.5001 4.14144C22.3242 4.14144 27.2071 8.17 28.5146 13.5926L32.932 18.0099C32.9771 17.5127 33.0002 17.009 33.0002 16.5001C33 7.38726 25.6127 0 16.5001 0C7.38743 0 0 7.38726 0 16.5001C0 17.6234 0.112386 18.7206 0.326265 19.7809",
    fill: "#40B4B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5298 22.0806C25.4911 26.1022 21.3175 28.8585 16.5001 28.8585C15.5449 28.8585 14.615 28.7501 13.722 28.545L10.4224 31.8446C12.3032 32.5902 14.3537 33 16.5001 33C22.4526 33 27.669 29.8479 30.5711 25.1217L27.5298 22.0806Z",
    fill: "#40B4B0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.178 24H47.99V8.6H60.178V12.384L57.12 16.3L60.178 20.238V24ZM56.944 11.614H51.004V21.008H56.944L53.27 16.3L56.944 11.614ZM70.5522 17.686H65.1622V21.008H74.3582L73.4122 24H62.1482V8.6H73.4122L74.3582 11.614H65.1622V14.672H71.4982L70.5522 17.686ZM84.7319 17.686H79.3419V21.008H88.5379L87.5919 24H76.3279V8.6H87.5919L88.5379 11.614H79.3419V14.672H85.6779L84.7319 17.686ZM103.114 24H100.1V21.91L93.5216 13.506V24H90.5076V8.6H93.6536L100.1 16.96V8.6H103.114V24ZM123.399 11.614H115.743V24H112.729V11.614H105.095L106.041 8.6H122.453L123.399 11.614ZM134.573 8.6H137.587V24H134.573V17.686H128.391V24H125.377V8.6H128.391V14.672H134.573V8.6ZM147.96 17.686H142.57V21.008H151.766L150.82 24H139.556V8.6H150.82L151.766 11.614H142.57V14.672H148.906L147.96 17.686ZM162.712 11.614H156.75V24H153.736V8.6H165.924V12.384L161.964 17.466L167.09 24H163.262L158.136 17.466L162.712 11.614ZM177.48 17.686H172.09V21.008H181.286L180.34 24H169.076V8.6H180.34L181.286 11.614H172.09V14.672H178.426L177.48 17.686Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10713_4553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.273b57fd2cf51cddbc67d9d388662872.svg";
export { ForwardRef as ReactComponent };